'use strict';

var Core = require('../core/core.js');
var Throbber = require('../throbber/throbber.js');

/**
 * Creates processing overlay
 *
 * @class
 */

class Processing extends Core {

    _defaults() {
        return {
            target: '.js-editor',
            fields: {}
        };
    }

    constructor(options) {
        super(options);

        this.template = `
            <div class="editor__processing">
                <div class="editor__processing__loading js-editor__processing__loading"></div>
                <div class="editor__processing__message js-editor__processing__message"></div>
            </div>
        `;

        super.render();

        // add throbber loading animation
        this.throbber = new Throbber({
            target: $('.js-editor__processing__loading', this.$el),
            fields: {
                theme: "light"
            }
        });

        // hide by default
        this.hide();
    }

    setMessage(message){
        $('.js-editor__processing__message', this.$el).html(message);
    }

    show(){
        this.$el.show();
    }

    hide(){
        this.$el.hide();
    }

}
module.exports = Processing;
